import React from 'react';
import {ALL_REACTIONS, ReactionsGroup} from "../../../model2/reaction/const";

type Props = {
    className?  : string
    onSelect : callback
    category : ReactionsGroup
}

export default function AddReaction_ReactionsGroup(props: Props) {

    const showGroup = !props.category.reactions.some((reaction)=>{
        return !gd.modules.reactions.disabledReactions.includes(reaction)
    })

    if(showGroup) return null

    return (
        <div className={props.className}>
            <div className="flex-row-left-center ui5-title-tiny h-30 m-l-5">{props.category.name}</div>
            <div className="group-items">
                {_.map(props.category.reactions, (reaction) => {

                     if (gd.modules.reactions.disabledReactions.includes(reaction)) return

                     return (
                         <div
                            className="ui5-control-button s-28 fs-18"
                            onClick={() => props.onSelect(reaction)}
                            key={props.category.name+reaction}>
                            {ALL_REACTIONS[reaction]}
                        </div>
                     )
                    }
                )}
            </div>
        </div>
    );
}